export default __webpack_public_path__ + "static/media/lunch5.6e0cce8e.png";